// @ts-nocheck
export default function sliderJS() {
  // ________ Слайдер __________

  // Устанавливаем индекс слайда по умолчанию
  let slideIndex = 1;
  let sliderDelay = 6000;

  // переключение слайдов
  function showSlides(slideIndex) {

    let slides = document.querySelectorAll(".useful-item");
    for (let slide of slides) {
      slide.addEventListener("click", nextSlide);
      slide.classList.remove("useful-item-active");
    }

    window.sliderTimeout1 = setTimeout(() => {
      for (let slide of slides) {
        if (slide) {
          slide.style.transform = `translateX(-${
            (slideIndex - 1) * (slide.offsetWidth + 30)
          }px)`;
        }
      }
    }, 500);

    window.sliderTimeout2 = setTimeout(() => {
      const slide = slides[slideIndex - 1];
      if (slide) {
        slide.classList.add("useful-item-active");
        slide.removeEventListener("click", nextSlide);
      }
    }, 750);

    const dots = document.querySelectorAll(".useful-dot-link");
    for (let dot of dots) {
      if (dot) {
        // присваиваем всем значение off
        dot.querySelector(".useful-dot-off").style.display = "block";
        // убираем у всех значение active
        dot.querySelector(".useful-dot-active").style.display = "none";
      }
    }

    const dot = dots[slideIndex - 1];
    if (dot) {
      // убираем у активной точки off
      dot.querySelector(".useful-dot-off").style.display = "none";
      // добавляем active активной точке
      dot.querySelector(".useful-dot-active").style.display = "flex";
    }
    autoSlider(sliderDelay);
  }

  // запуск нового таймера переключения слайдов
  function autoSlider(sliderDelay) {
    window.autoSliderTimeout = setTimeout(() => {
      if (slideIndex === 4) {
        slideIndex = 1;
      } else {
        slideIndex += 1;
      }
      showSlides(slideIndex);
    }, sliderDelay);
  }

  // создаем функции для переключение карточек по точкам
  const dot1 = () => {
    slideIndex = 1;
    clearTimeout(window.autoSliderTimeout);
    showSlides(slideIndex);
  };
  document.querySelector("#dot1").addEventListener("click", dot1);
  const dot2 = () => {
    slideIndex = 2;
    clearTimeout(window.autoSliderTimeout);
    showSlides(slideIndex);
  };
  document.querySelector("#dot2").addEventListener("click", dot2);

  const dot3 = () => {
    slideIndex = 3;
    clearTimeout(window.autoSliderTimeout);
    showSlides(slideIndex);
  };
  document.querySelector("#dot3").addEventListener("click", dot3);

  const dot4 = () => {
    slideIndex = 4;
    clearTimeout(window.autoSliderTimeout);
    showSlides(slideIndex);
  };
  document.querySelector("#dot4").addEventListener("click", dot4);

  // клик по картинке сбоку
  function nextSlide() {
    if (slideIndex === 4) {
      slideIndex = 1;
    } else {
      slideIndex += 1;
    }
    clearTimeout(window.autoSliderTimeout);
    showSlides(slideIndex);
  }
  showSlides(slideIndex);
}
